import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c5ab1f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live-comment-container" }
const _hoisted_2 = { class: "live-comment" }
const _hoisted_3 = { class: "live-comment-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "live-input" }, [
  /*#__PURE__*/_createElementVNode("span", null, "说点什么")
], -1 /* HOISTED */))
const _hoisted_5 = { class: "live-like" }
const _hoisted_6 = {
  key: 0,
  class: "live-like-num"
}

import {withDefaults, computed, ref, watch, nextTick} from 'vue';
import {download, getScrollTop, scrollToTop} from 'common/util';
import {useTimStore} from 'v-store/module/tim';
import {TextMsg} from 'common/types/tim.types';
import {useNullable} from 'v-hook/common';
import config from 'site-config';
import {DynamicScroller, DynamicScrollerItem} from 'vue-virtual-scroller';
import LiveCommentItem from './live-comment-item.vue';
import throttle from 'lodash.throttle';


export default /*#__PURE__*/_defineComponent({
  props: {
    hostUid: { default: '' }
  },
  setup(__props: any) {



const timStore = useTimStore();

const groupInfo = computed(() => timStore.groupInfo);

const renderMessages = ref<Array<TextMsg>>([]);
const notRenderMessages = ref<Array<TextMsg>>([]); // 未渲染的消息
const canAppendMessage = ref<boolean>(true); // 是否可以添加新消息
const scroller = useNullable<DynamicScroller>(null);
const scrollEl = computed<HTMLElement>(() => scroller.value?.$el);
const newMessageNum = ref<number>(0);

/**
 * 计算未渲染的新消息数量
 * @param newMessages 新消息
 * @param oldMessages 旧消息
 */
const calcNewMessage = (newMessages, oldMessages) => {
    const oldLastMessage = oldMessages[0];
    const index = newMessages.findIndex(item => item.msgId === oldLastMessage.msgId);
    const num = index > -1 ? index : newMessages.length;
    notRenderMessages.value = newMessages.slice(0, num);
    newMessageNum.value = num;
};

watch(
    () => timStore.messages,
    newMessages => {
        if (canAppendMessage.value) {
            return (renderMessages.value = newMessages);
        }
        // 计算新消息数量、保存新消息
        calcNewMessage(newMessages, renderMessages.value);
    },
    {
        immediate: true
    }
);

const SCROLL_THROTTLE_TIME = 100, // 节流wait time
    SCROLL_LIMIT_TOP = 100; // 滚动到限制距离后不能添加新消息

const prependNewMessage = () => {
    newMessageNum.value = 0;
    nextTick(() => {
        renderMessages.value = [...notRenderMessages.value, ...renderMessages.value].slice(
            0,
            config.TIM.LIMIT_MESSAGE_COUNT
        );
        canAppendMessage.value = true;
        notRenderMessages.value = [];
    });
};

const scrollCanAppendMessage = () => {
    const scrollTop = getScrollTop(scrollEl.value);
    if (scrollTop > SCROLL_LIMIT_TOP) {
        canAppendMessage.value = false;
        return;
    }
    prependNewMessage();
};

const methods = {
    scroll: throttle(scrollCanAppendMessage, SCROLL_THROTTLE_TIME),
    clickNewMsg: () => {
        scrollToTop(scrollEl.value);
        prependNewMessage();
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createCommentVNode(" 1. 进入直播间提示 "),
        _createCommentVNode(" 2. 评论消息 "),
        _createVNode(_unref(DynamicScroller), {
          ref_key: "scroller",
          ref: scroller,
          class: "live-comment-list",
          items: renderMessages.value,
          "min-item-size": 68,
          "key-field": "msgId",
          onScroll: methods.scroll
        }, {
          default: _withCtx(({item, index, active}) => [
            _createVNode(_unref(DynamicScrollerItem), {
              item: item,
              active: active,
              "size-dependencies": [item.msg, item.username],
              "data-index": index
            }, {
              default: _withCtx(() => [
                _createVNode(LiveCommentItem, {
                  info: item,
                  "host-uid": __props.hostUid
                }, null, 8 /* PROPS */, ["info", "host-uid"])
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["item", "active", "size-dependencies", "data-index"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["items", "onScroll"])
      ]),
      (newMessageNum.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "live-comment-new",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (methods.clickNewMsg && methods.clickNewMsg(...args)))
          }, [
            _createElementVNode("span", null, _toDisplayString(newMessageNum.value < 100 ? newMessageNum.value : '99+') + "条新消息", 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("section", {
      class: "live-action",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(download) && _unref(download)(...args)))
    }, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_unref(groupInfo).like_num)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(groupInfo).like_num_str), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}
}

})